import PropTypes from 'prop-types'
import React, { Fragment, useEffect } from 'react'

import { makeStyles } from '@material-ui/core/styles'

import { Alert, AlertTitle } from '@material-ui/lab'

import { useApplicationApiRequest } from '../hooks/useApplicationApi'

import VotingInfo from './VotingInfo'
import VotingPlayerInfo from './VotingPlayerInfo'
import VotingDemoVideo from '../voting/VotingDemoVideo'
import { variant } from './constants/selection_process'

import headerImage from '../../assets/images/header/header-image.png'

const styles = (theme) => ({
  card: {
    backgroundColor: 'transparent',
    boxShadow: 'none',
  },
  cardMedia: {
    width: '100%',
  },
  heading: {
    backgroundColor: theme.palette.primary.light,
    color: '#ffffff',
  },
  headingExpandIcon: {
    color: '#ffffff',
  },
  headingTitle: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightBold,
  },
  content: {
    padding: 0,
  },
  alertBlock: {
    flex: 1,
  },
  divider: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  poweredByContainer: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
  },
  poweredByLogos: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
  },
  poweredByLogo: {
    margin: theme.spacing(1),
  },
  spacing: {
    width: '32px',
  },
})
const useStyles = makeStyles(styles)

export default function VotingContainer(props) {
  const {
    authorizationToken,
    isAuthenticated,
    origins,
    setAuthenticated,
    slug,
  } = props

  const apiRequest = useApplicationApiRequest(`/hackathon/voting/team`, {
    autoExecute: false,
    params: { origins, slug, variant },
  })
  const { error, execute, isLoading, response } = apiRequest

  useEffect(() => {
    execute({
      headers: { Authorization: `Bearer ${authorizationToken}` },
    })
  }, [authorizationToken, execute])

  const classes = useStyles()

  useEffect(() => {
    if (!error && !isLoading && response) {
      setAuthenticated(true)
    }
  }, [error, isLoading, response, setAuthenticated])

  if (isLoading) {
    throw Promise.resolve(null)
  }

  if (error) {
    return (
      <Alert severity="error">
        <AlertTitle>Oops!</AlertTitle>
        Não foi possível carregar os dados da equipe.
        <br />
        Por favor, verifique se o link está correto e tente novamente.
      </Alert>
    )
  }

  if (!isAuthenticated) {
    return null
  }

  if (!response) {
    return null
  }

  const reportDataB = response.data.b[response.data.b.length - 1]
  const reportDataC = response.data.c[response.data.c.length - 1]

  const teamMembers = reportDataC
    ? ['_a', '_b', '_c', '_d', '_e']
        .filter(
          (suffix) =>
            reportDataC[`team_member${suffix}_name`] &&
            reportDataC[`team_member${suffix}_name`].length > 0,
        )
        .map((suffix) => ({
          id: reportDataC[`team_member${suffix}`],
          name: reportDataC[`team_member${suffix}_name`],
        }))
    : []

  return (
    <Fragment>
      <img alt="Header" className={classes.cardMedia} src={headerImage} />

      {!!reportDataC && (
        <Fragment>
          <VotingInfo
            authorizationToken={authorizationToken}
            description={reportDataC.solution_madlib}
            title={reportDataC.solution_name}
            teamMembers={teamMembers.map((member) => member.name)}
          />

          <VotingPlayerInfo
            authorizationToken={authorizationToken}
            deckId={reportDataC.deck_id}
            title="PITCH"
            recordingId={reportDataC.recording_id}
          />

          <VotingDemoVideo
            title="VÍDEO DEMO"
            link={reportDataB.proposal_demo_video}
          />
        </Fragment>
      )}
    </Fragment>
  )
}

VotingContainer.propTypes = {
  authorizationToken: PropTypes.string,
  isAuthenticated: PropTypes.bool,
  origins: PropTypes.arrayOf(PropTypes.string).isRequired,
  slug: PropTypes.string.isRequired,
}
